<!-- src/components/Sidebar.vue -->
<template>
  <div class="sidebar">
    <img src="@/assets/logo_horizontal.webp"/>
    <nav>
      <router-link v-if="user.role==='superAdmin'" to="/company" active-class="selected" class="menu-item">
        <img src="@/assets/ic_navi_company.svg" alt="公司管理" class="icon"/>
        公司管理
      </router-link>
      <router-link v-if="user.role!=='user'" to="/account" active-class="selected" class="menu-item">
        <img src="@/assets/ic_navi_account.svg" alt="公司管理" class="icon"/>
        帳號管理
      </router-link>
      <router-link to="/event" active-class="selected" class="menu-item">
        <img src="@/assets/ic_navi_event.svg" alt="公司管理" class="icon"/>
        事件管理
      </router-link>
      <router-link to="/cleaning-log" active-class="selected" class="menu-item">
        <img src="@/assets/ic_navi_cleaning_record.svg" alt="藥洗紀錄" class="icon"/>
        藥洗紀錄
      </router-link>
      <router-link to="/device" active-class="selected" class="menu-item">
        <img src="@/assets/ic_navi_device.svg" alt="公司管理" class="icon"/>
        設備管理
      </router-link>
      <router-link to="/report" active-class="selected" class="menu-item">
        <img src="@/assets/ic_navi_report.svg" alt="公司管理" class="icon"/>
        報表
      </router-link>
    </nav>

    <div class="profile-card">
      <div class="profile-info">
        <h3>{{ user.last_name + user.first_name }}</h3>
        <p>{{ $t(`roles.${user.role}`) }}</p>
      </div>
      <a-dropdown :trigger="['click']">
        <span class="menu-icon">⋮</span>
        <template #overlay>
          <a-menu>
            <a-menu-item key="0">
              <a @click="()=>this.$router.push('/profile')">檢視帳號</a>
            </a-menu-item>
            <a-menu-divider/>
            <a-menu-item key="1">
              <a @click="logout" style="color: red">登出</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
    <span class="copyright">Copyright © 2024 彰化鍊水科技股份有限公司</span>
  </div>
</template>

<script>
export default {
  inject: ['getUserData', 'clearUserData'],
  name: "SidebarComponent",
  data() {
    return {};
  },
  computed: {
    user() {
      return this.getUserData();
    },
  },
  mounted() {
    console.log(this.getUserData());
  },
  methods: {
    logout() {
      this.clearUserData();
      this.$router.push('/login')
    }
  }
};
</script>

<style scoped>
.sidebar {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  width: 230px;
  background-color: white;
  height: 100vh;
  padding: 24px 24px 0 24px;
  border-top-right-radius: 28px;
  border-bottom-right-radius: 28px;
  text-align: center;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

nav {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-grow: 1;
  padding: 40px 0 0 20px;
  text-align: left;
}

nav a {
  text-decoration: none;
  color: black;
}

nav a * {
  vertical-align: text-bottom;
}

.menu-item.selected {
  font-weight: bold;
  color: blue;
}

.menu-item img {
  width: 24px;
  height: 24px;
  filter: grayscale(100%);
  opacity: 0.5;
  transition: filter 0.3s ease;
}

.menu-item.selected img {
  filter: grayscale(0%);
  opacity: 1;
}

.profile-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  text-align: left;
  padding: 10px;
  cursor: pointer;
  background-color: #f5f5fa;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.profile-info h3 {
  font-size: 14px;
  margin: 0;
  color: #333;
}

.profile-info p {
  font-size: 12px;
  color: #777;
  margin: 0;
}

.menu-icon {
  font-size: 20px;
  cursor: pointer;
}

.copyright {
  color: #999999;
  font-size: 12px;
}
</style>
